import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../../service/auth/auth.service';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(
        private authService: AuthService,
        private cookieService: CookieService
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token = this.authService.getToken();
        const csrfToken = this.cookieService.get('csrfToken');

        // Headers a incluir
        const headers: { [key: string]: string } = {};

        if (token) {
            headers['Authorization'] = token; // Si ya incluye "Bearer", no lo duplicamos
        }

        // Solo en métodos que pueden modificar datos
        const isMutatingMethod = ['POST', 'PUT', 'DELETE', 'PATCH'].includes(req.method.toUpperCase());
        if (csrfToken && isMutatingMethod) {
            headers['X-CSRF-Token'] = csrfToken;
        }

        const clonedRequest = req.clone({
            setHeaders: headers,
            withCredentials: true
        });

        return next.handle(clonedRequest).pipe(
            catchError((error: HttpErrorResponse) => {
                if (
                    error.status === 401 &&
                    error.error?.message?.includes('Token revocado. Por favor inicia sesión nuevamente.')
                ) {
                    this.authService.triggerRevokedTokenModal();
                }
                return throwError(() => error);
            })
        );
    }
}
